<script setup lang="ts">
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";

import Modal from "./Modal.vue";
import PensionEligibilityQuestions from "./PensionEligibilityQuestions.vue";
import TaxFreeExceedOptions from "./TaxFreeExceedOptions.vue";
import { getStores } from "@/stores";

defineProps<{
    modelValue: boolean;
}>();

const emit = defineEmits<{
    (on:"update:modelValue", value: boolean): void
    (on:"requote"): void
}>();

function closeModal() {
    emit("update:modelValue", false);
}
const v$ = useVuelidate();

const answersInvalid = computed(() => {
    const { pensionOptionsStore } = getStores();

    return pensionOptionsStore.pensionType !== true ||
        pensionOptionsStore.fundTransferred !== false ||
        pensionOptionsStore.guaranteeAnnuityRate !== false ||
        pensionOptionsStore.moreThanTwentyFive !== false || v$.value.$invalid;
});

</script>

<template>
    <Modal
        id="ams-handoff-questions-modal"
        :show="modelValue"
        header="Legal & General customers"
        subheader="To make sure we can provide you with quotes please answer the following questions:"
        @close="closeModal"
    >
        <template #body>
            <PensionEligibilityQuestions />
            <TaxFreeExceedOptions />
            <!-- phone number question - ARR-643 -->
            <div class="modal-control">
                <button
                    id="ams-handoff-questions-modal-requote-button"
                    type="button"
                    class="btn"
                    :class="answersInvalid ? 'btn-danger' : 'btn-forward'"
                    :disabled="answersInvalid"
                    @click="emit('requote')"
                >
                    Get guaranteed quotes
                </button>
            </div>
        </template>
    </Modal>
</template>

<style scoped>
.modal-control {
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-control button {
    width: 300px;
    height: 50px;
    margin: 0;
    padding: 0px !important;
}
</style>
